import React, { useRef, useState } from 'react'
import * as styles from './styles.module.scss'
import displayPriceVavue from '../../helpers/displayPriceValue'
import parse from 'html-react-parser'
import { getShuffledArr, getMeasureUnit, getBuzzy } from '../../helpers/functions'
import { Link } from 'gatsby'
import translate from '../../helpers/Translate'

export const CompareProductsTable = ({ 
    roundupProducts, 
    isSingleProduct, 
    spProducts,
    currentProduct,
    isSelected,
    featuresItems,
}) => {

    
    const sectionRef = useRef( null )

    let compareProducts = []

    let availableCompareRows = []

    const [ showMore, setShowMore ] = useState( false )

    const [ singleProdustc, setSingleProducts ] = useState( isSingleProduct ? isSelected ? spProducts : (spProducts.length > 2 ? getShuffledArr( spProducts ) : spProducts) : [] )

    let producsts

    if( isSingleProduct ) {
        let tmp = []

        if( isSelected ){
            singleProdustc?.forEach( prod => {
                tmp.push( prod.node )
            })
        } else {
            const currentProductCutegory = currentProduct?.roundupcategories?.nodes[0]?.slug

            singleProdustc?.forEach( prod => {
                if( currentProductCutegory ===  prod?.node?.roundupcategories?.nodes[0]?.slug ) {
                    tmp.push( prod.node )
                }
            })
        }
        

        tmp.push({...currentProduct, uri : 'shop-bar1'})

        tmp = tmp?.reverse()

        producsts = tmp?.slice( 0, 6 )
        
    } else {
        producsts = roundupProducts?.products
    }


    let pr2 = []

    let availableRows = [ 
            'Overall score', 
            'Bedbible rating', 
            'User rating', 
            'Price', 
            'Design',
            'Ease of use', 
            'Quality', 
            'Sound', 
            'Power', 
            'Buzzy/Rumbly',
    ]

    if ( ! isSingleProduct ) {
        availableRows.unshift( 'Best' )
    }

    producsts.forEach(( prod, id ) => {

        let ratings = []

        if( isSingleProduct ) {
            prod?.singleProductReview?.opretShopBarSingle?.forEach(item => {
                item.review !== null && ratings.push({ review : item.review, numberReviews : item.numberReviews })
            })
        } else {
            prod.opretShopBar?.forEach(item => {
                item.review !== null && ratings.push({ review : item.review, numberReviews : item.numberReviews })
            })
        }

        let rating = 0

        let totalRevievs = 0 

        ratings.forEach( item => {

                totalRevievs = totalRevievs + item.numberReviews 

                rating = rating + ( item.numberReviews * item.review )

        })

        rating = parseFloat( ( rating / totalRevievs ).toFixed(1) )

        if( isSingleProduct ) {
                prod?.singleProductReview?.featuresSingle?.forEach(( feature ) => {

                    availableRows.push( feature.selectFeature )
    
                })
        } else {
            if ( prod?.features !== null ) {
                prod?.features?.forEach(( feature ) => {
                    availableRows.push( feature.selectFeature )
                })
            }
        }

        let features2 = []

        if( isSingleProduct ) {
            features2 = prod?.singleProductReview?.featuresSingle
        } else {
            if ( prod.features !== null ) {
                features2 = prod.features
            }
        }
           
        let orRating 

        if( isSingleProduct ) {

            orRating = ( prod?.singleProductReview?.ratingProSingle + rating ) / 2

            features2?.push({ selectFeature : 'Overall score', text2Column : orRating.toFixed(1) + ' / 5.0'  })

            features2?.push({ selectFeature : 'Bedbible rating', text2Column : prod.singleProductReview.ratingProSingle !== null ? prod.singleProductReview.ratingProSingle.toFixed(1) + ' / 5.0' : 'N/A' })

            features2?.push({ selectFeature : 'User rating', text2Column : rating + ' / 5.0' + translate('<br> from ' + totalRevievs + ' users', totalRevievs)})

            const priceReduced = prod?.singleProductReview?.priceRating / 100 * 5

            features2?.push({ selectFeature : 'Price', text2Column : displayPriceVavue(priceReduced) })

            features2?.push({ selectFeature : 'Design', text2Column : prod.singleProductReview.designRating + ' / 100' })

            features2?.push({ selectFeature : 'Ease of use', text2Column : prod.singleProductReview.easeOfUseRating + ' / 100' })

            features2?.push({ selectFeature : 'Quality', text2Column : prod.singleProductReview.qualityRating + ' / 100' })

            if ( prod?.singleProductReview?.isItAVibratorSingle ) {
                features2?.push({ selectFeature : 'Sound', text2Column : prod.singleProductReview.soundSingle + ' / 100' })

                features2?.push({ selectFeature : 'Power', text2Column : prod.singleProductReview.vibrationStrengthSingle + ' / 100' })

                features2.push({ selectFeature : 'Buzzy/Rumbly', text2Column : translate( getBuzzy( prod.singleProductReview.vibrationStrengthSingle  ) ) })
            }

        } else {

            orRating = ( prod.ratingPro + rating ) / 2

            features2.push({ selectFeature : 'Best', text2Column : prod?.specialTitlePro })

            let orratingToDisplay

            if ( ! isNaN( orRating ) ) {
                orratingToDisplay = orRating.toFixed(1) + ' / 5.0'
            } else {
                orratingToDisplay = '-'
            }

            features2.push({ selectFeature : 'Overall score', text2Column : orratingToDisplay })

            features2.push({ selectFeature : 'Bedbible rating', text2Column : prod.ratingPro !== null ? prod.ratingPro.toFixed(1) + ' / 5.0' : 'N/A' })

            let ratingToDisplay

            if ( ! isNaN( rating ) ) {
                ratingToDisplay = rating + ' / 5.0' + translate('<br> from ' + totalRevievs + ' users', totalRevievs)
            } else {
                ratingToDisplay = '-'
            }

            features2.push({ selectFeature : 'User rating', text2Column : ratingToDisplay })

            const priceReduced = prod.price / 100 * 5

            features2.push({ selectFeature : 'Price', text2Column : displayPriceVavue(priceReduced) })

            features2.push({ selectFeature : 'Design', text2Column : prod.design + ' / 100' })

            features2.push({ selectFeature : 'Ease of use', text2Column : prod.easeofuse + ' / 100' })

            features2.push({ selectFeature : 'Quality', text2Column : prod.quality + ' / 100' })

            if ( prod.isItAVibrator ) {
                features2.push({ selectFeature : 'Sound', text2Column : prod.sound + ' / 100' })

                features2.push({ selectFeature : 'Power', text2Column : prod.vibrationStrength + ' / 100' })

                features2.push({ selectFeature : 'Buzzy/Rumbly', text2Column : translate( getBuzzy( prod.vibrationStrength ) )})
            }
         
        }

        let featuredImage
        let srcSetVal
        let sizesVal

        let title

        if ( isSingleProduct ) {
            featuredImage = prod?.featuredImage?.node?.sourceUrl
            title = prod?.singleProductReview?.dynamicLabel1
        } else {
            featuredImage = prod.gallery !== null ? prod.gallery[0]?.sourceUrl : ''
            srcSetVal = prod.gallery !== null ? prod.gallery[0]?.srcSet : ''
            sizesVal = prod.gallery !== null ? prod.gallery[0]?.sizes : ''
            title = prod.shouldBuyTitle
        }

        pr2.push({
            name : title,
            image : featuredImage,
            srcSet : srcSetVal,
            sizes : sizesVal,
            rating : rating.toFixed(1),
            label : prod?.specialTitlePro,
            faetures : features2,
            id : id,
            url : prod?.uri,
            anchor : prod?.shouldBuyTitle?.replaceAll(' ', '_')
        })
    })

      

    function onlyUnique( value, index, self ) {

        return self.indexOf(value) === index

    }

    const unique = availableRows.filter( onlyUnique )

    let redProducts = []

        pr2.forEach( product => {

        let tmpPr = product

        let tmpFeatures = product.faetures

        let t = []

        unique.forEach( ( un, id ) => {

            var result = tmpFeatures?.find(item => item.selectFeature === un)
                
            if( result !== undefined ) {
                t.push({...result, text2Column : result.text2Column + ' ' + getMeasureUnit( result.selectFeature, featuresItems )})
            } else {
                t.push({ selectFeature : un, text2Column : '-'})
            }
               
        })

        tmpPr = {...tmpPr, faetures : t }

        redProducts.push( tmpPr )
           
    })

    compareProducts = redProducts

    availableCompareRows = unique

    const handleShowMore = () => {
        if( showMore ) {
            window.scrollTo({
                top: sectionRef.current.offsetTop,
                left: 0,
                behavior: "smooth",
            })
        }
        
        setShowMore( ! showMore )
    }

    const handleScroll = ( id ) => {

        let violation = document.getElementById( id )

        if( isSingleProduct ) {
            violation = document.getElementById( id )
        }

        const timeout = window.innerWidth > 500 ? 300 : 500

        setTimeout(() => {
            window.scrollTo({
                top:violation.offsetTop,
                behavior : 'smooth'
            })
        }, timeout)

    }

    // let dynamicLabel =  translate(`Comparison of the ${compareProducts.length} best ${roundupProducts?.dynamicLabel2}`, compareProducts.length, roundupProducts?.dynamicLabel2)
    let dynamicLabel = translate( 'Comparison' )


    if ( isSingleProduct ) {
        dynamicLabel =  translate(`Comparing <span>${currentProduct?.singleProductReview?.dynamicLabel1}</span> with <span>alternatives</span>`, currentProduct?.singleProductReview?.dynamicLabel1)
    } 

    return(
        <>
        <section className={`${styles.compare__table} ${showMore ? styles.show__more : ''}`} ref={sectionRef} id={'compareTable'}>
            <div className={`wrapper-roundup ${isSingleProduct ? styles.compare__single : ''}`}>
                <h2 className={styles.title} style={{ textAlign : isSingleProduct ? 'left' : 'left' }}>{parse( dynamicLabel )}</h2>
            </div>
            <div className='wrapper table-wrapper-2'>
                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th className={`${styles.sticky__col} ${styles.first__col} f-col`} id='Option'></th>
                            {compareProducts.map( ( product, id ) => 
                                product.name !== undefined &&
                                <th className='top-img temp' key={`hd-${id}`} id={product?.name?.replaceAll(' ', '_')}>
                                    <div>
                                        <img 
                                            srcSet={product.srcSet}
                                            sizes={product.sizes}
                                            className={styles.main__img} 
                                            alt={'Compare ' + product.name} 
                                            src={product.image} />
                                        {/* <GatsbyImage 
                                            cssstyle="object-fit: contain !important;" 
                                            image={product.image} 
                                            alt={product.name} 
                                            className={styles.main__img} /> */}
                                        {isSingleProduct ? 
                                        id === 0 ?
                                        <span onClick={() => handleScroll( product.url)} className={styles.product__name}>{product.name}</span>
                                        :
                                        <Link to={product.url} className={styles.product__name}>{product.name}</Link>
                                        :   
                                        <a href={`#${product.anchor}`} onClick={() => handleScroll( product.anchor )} className={styles.product__name}>
                                            {product.name}
                                        </a>}
                                    </div>
                                </th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {availableCompareRows.map( ( row, id ) =>    
                            <tr key={`rw-${id}`}>
                                <td 
                                    headers={'Option'}
                                    className={`${styles.sticky__col} ${styles.first__col} f-col`}>{translate( row )}</td>
                                {compareProducts.map( product => 
                                product.name !== undefined &&
                                    product.faetures.map( ( f, i ) => 
                                        row === f.selectFeature 
                                        && 
                                        <td key={`itm-${i}`} headers={product?.name?.replaceAll(' ', '_')}>
                                            {f.text2Column ? parse(f.text2Column) : f.text2Column}
                                        </td>
                                    )    
                                )}
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </section>
        <section className='show-more-section'>
            <div className='wrapper'>
                <span className={styles.more__btn} onClick={() => handleShowMore()}>
                    {showMore ? translate('Show Less') : translate('Show More')}
                </span>
            </div>
        </section>
        </>
    )
}